<template>
  <div class="contact-info mb-5">
    <div class="mb-2">
      <font-awesome-icon
        icon="phone-alt"
        class="mr-1"
      />
      {{ siteConfig.tel }}
    </div>

    <div class="">
      <font-awesome-icon
        icon="envelope"
        class="mr-1"
      />
      {{ siteConfig.email }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'members'
    }
  },

  created () {
    this.$store.dispatch(`${this.modelName}/getSiteConfig`)
  },

  computed: {
    siteConfig () {
      return this.$store.getters[`${this.modelName}/getAttr`]('siteConfig')
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-info {
  border-radius: 4px;
  border: 2px solid gray;
  padding: 16px;
  font-size: 1.2rem;
}
</style>
